module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-gtag@5.14.0_gatsby@5.14.4_babel-eslint@10.1.0_eslint@9.28.0__encoding@0._52fkag7ybijtqukqw6mrybimyy/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-167628835-2"],"gtagConfig":{}},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-jss@5.14.0_gatsby@5.14.4_babel-eslint@10.1.0_eslint@9.28.0__encoding@0.1.13_rea_q2fkbnjdjmnpsuldyo4bls3jdy/node_modules/gatsby-plugin-jss/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-layout@4.14.0_gatsby@5.14.4_babel-eslint@10.1.0_eslint@9.28.0__encoding@0.1.13__6kvunym2ukcq44gnor4ghvmomm/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.4_babel-eslint@10.1.0_eslint@9.28.0__encoding@0.1.13_react-dom@18.3.1_react@18.3._uqxrra6kdnbhywoiyuhf3q4yce/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
